import { useEffect } from 'react';
import {
  Dialog,
  ButtonSize,
  Typography,
  ButtonVariant,
  PrimaryButton,
} from '@uni-of-exeter/digital.lib.react.ui.kit';

import './progress-info-modal.css';
import { APP_TEXT } from '../../const/app-text';

// ------------------------------------------------------------

const text = APP_TEXT.components.progressInfoModal;

export interface ProgressInfoModalProps {
  isOpen: boolean;
  onSave?: () => void;
  onClose: () => void;
}

const ProgressInfoModal = ({ isOpen, onClose }: ProgressInfoModalProps) => {
  useEffect(() => {
    if (isOpen === true) {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = 'blur(4px)';
    } else {
      const rootElement = document.getElementById('root');
      if (!rootElement) {
        return;
      }
      rootElement.style.filter = '';
    }
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      footer={<></>}
      className="progressInfoModal"
    >
      <div
        className="progressInfoModalWrapper"
        aria-modal
        role="alertdialog"
        aria-label="Resource Location Modal"
      >
        <div className="progressInfoModalContent">
          <Typography
            variant="h2"
            fontWeight={700}
          >
            {text.title}
          </Typography>

          <div className="contentBody">
            <Typography variant="body">{text.body}</Typography>
          </div>
        </div>

        <div className="progressInfoModalButton">
          <PrimaryButton
            variant={ButtonVariant.Solid}
            size={ButtonSize.Large}
            onClick={onClose}
          >
            {text.close}
          </PrimaryButton>
        </div>
      </div>
    </Dialog>
  );
};

export default ProgressInfoModal;
